import { FC, useContext } from "react";
import Link from "next/link";
import {
  InnerWrapper,
  Wrapper,
  Image,
  RelatedArticleItem,
  RelatedArticleText,
} from "./RelatedArticle.styled";
import { imageItemUrl } from "common/Utils/images";
import { PublicationContext } from "common/context/Publication";
import { publicationTypes } from "common/context/Publication/PublicationContext";

interface Props {
  data: {
    links?: {
      id?: string;
      href: string;
      title?: string;
      image?: string;
    }[];
  };
}

const RelatedArticle: FC<Props> = ({ data }) => {
  const { publication } =
  useContext<publicationTypes>(PublicationContext);

  if (!data) {
    return null;
  }
  return (
    <Wrapper>
      <div className="title">Also in the news</div>
      <InnerWrapper>
        {data.links?.map((item, i) => {
          const image = item.image ? item.image : "/images/placeholder.jpg";
          return (
            <a key={i} href={item.href}>
              <RelatedArticleItem>
                <Image src={imageItemUrl( publication, image, 3)} alt={item.title} />
                <RelatedArticleText>{item.title}</RelatedArticleText>
              </RelatedArticleItem>
            </a>
          );
        })}
      </InnerWrapper>
    </Wrapper>
  );
};

export default RelatedArticle;
